<script>
import RexTableCompV2 from '@/rex-components/rex-TableCompV2.vue';
import NoData from '@/rex-components/rex-no-data.vue';
import { LOGService } from '@/services/api/log.service';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import copy from '@/utils/copy';
import { notificationSucess } from '@/utils/notification';
import { getRandomUniqueId, customSplitString } from '@/utils/helper-function';
import {
  LOG_QUERY_TABLE_LIMIT,
  timeStamp,
  timeStampEpoch,
  timeStampFormat,
  TRACE_ID,
  eventTS,
} from '@/components/Log/log.constants';
import { formatDate } from '@/utils/time/formatDate';
import { getTimeZone } from '@/utils/time/timezone';
import debounce from 'lodash/debounce';
import { getTimeZoneOffset } from '@/utils/time/timeZoneOffset';
import { getRouteName } from '@/components/Log/log.types';

export default {
  components: { RexTableCompV2, NoData },
  computed: {
    ...mapState('globalState/user', ['teamID']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('logState/logCommonState', [
      'queryHeaders',
      'queryDataLoading',
      'freeSearchSources',
      'isADType',
      'isAPMCorrelation',
      'isADType',
    ]),
    ...mapGetters('logState/logCommonState', ['getCapabilityType']),
    ...mapState('globalState/settings', ['timezoneoffset']),
    ...mapState('apmState/trace', ['currentTraceId']),
    dispNoDataMessage() {
      return (
        (this.items?.length > 0 && this.headers?.length === 0) ||
        !!this.errorMsg
      );
    },
    dispInfiniteFooter() {
      return this.stopInfiniteScroll && this.items?.length > 18;
    },
    dispScrollFooter() {
      return this.items?.length > 18;
    },
  },
  data() {
    return {
      headers: [],
      items: [],
      loading: false,
      stopInfiniteScroll: false,
      errorMsg: '',
      isSrollErrMsg: '',
      offset: 0,
      isDestroyed: false,
    };
  },
  methods: {
    ...mapMutations('logState/logCommonState', [
      'setQueryHeaders',
      'setQueryDataLoading',
      'setQueryEnableSavedSearchType',
    ]),
    ...mapMutations('globalState/app', ['setHideDateTimePicker']),
    ...mapActions('apmState/trace', ['TRACE_DETAIL_EXIST']),
    ...mapMutations('apmState/trace', ['setCurrentTraceId']),
    getRandomUniqueId,
    formatTableResp(list) {
      return list.map((item) => {
        if (timeStamp in item) {
          item[timeStamp] =
            formatDate(item[timeStamp], this.timezoneoffset, timeStampFormat) +
            getTimeZoneOffset(this.timezoneoffset);
        }
        if (timeStampEpoch in item) {
          item[timeStampEpoch] =
            formatDate(
              item[timeStampEpoch],
              this.timezoneoffset,
              timeStampFormat,
            ) + getTimeZoneOffset(this.timezoneoffset);
        }
        if (eventTS in item) {
          item[eventTS] =
            item[eventTS] === 0 || item[eventTS] === '-'
              ? '-'
              : formatDate(
                  item[eventTS],
                  this.timezoneoffset,
                  timeStampFormat,
                ) + getTimeZoneOffset(this.timezoneoffset);
        }
        return { _id: `${getRandomUniqueId()}`, ...item };
      });
    },
    handleAddNavOptions(enableSavedSearchType) {
      this.setQueryEnableSavedSearchType(enableSavedSearchType);
    },
    async queryTextExec(query) {
      try {
        this.errorMsg = '';
        this.isSrollErrMsg = '';
        this.loading = true;
        const params = {
          query: query,
          limit: LOG_QUERY_TABLE_LIMIT,
          offset: this.offset,
          team_id: this.teamID,
          timeZone: getTimeZone(this.timezoneoffset),
          sources: this.freeSearchSources,
          duration: this.getDurationTime,
        };
        const { data } = await LOGService.applyTextQuery(params);
        if (data.success) {
          this.handleAddNavOptions('');
          const dataWithTraceDetails = await this.checkAPMTraceDetailExist(
            data.data.rows,
          );
          this.items =
            this.offset === 0
              ? this.formatTableResp(dataWithTraceDetails)
              : [...this.items, ...this.formatTableResp(dataWithTraceDetails)];
          if (data.data.rows?.length < LOG_QUERY_TABLE_LIMIT) {
            this.stopInfiniteScroll = true;
          }

          const headersList = data?.data?.columns ?? [];
          this.updateQueryHeaders(headersList);
          this.updateSelectedHeaders(this.queryHeaders);
        } else {
          this.setQueryHeaders([]);
          this.updateSelectedHeaders([]);
        }
        this.loading = false;
        this.queryDataLoading && this.setQueryDataLoading(false);
      } catch (error) {
        this.stopInfiniteScroll = true;
        this.handleQueryDataError(error);
        this.loading = false;
        this.queryDataLoading && this.setQueryDataLoading(false);
        console.log('error', error);
      }
    },
    async getSqlExecData(query) {
      try {
        this.errorMsg = '';
        this.isSrollErrMsg = '';
        this.loading = true;
        const params = this.currentTraceId
          ? {
              limit: LOG_QUERY_TABLE_LIMIT,
              offset: this.offset,
              team_id: this.teamID,
              traceId: this.currentTraceId,
              duration: this.getDurationTime,
            }
          : {
              query: query,
              limit: LOG_QUERY_TABLE_LIMIT,
              offset: this.offset,
              team_id: this.teamID,
              timeZone: getTimeZone(this.timezoneoffset),
              duration: this.getDurationTime,
              capability: this.getCapabilityType,
            };
        const { data } = this.currentTraceId
          ? await LOGService.applyAPMCorrelationQuery(params)
          : await LOGService.applySqlQuery(params);
        if (data.success && !this.isDestroyed) {
          this.handleAddNavOptions(data.data.savedQueryType);
          const dataWithTraceDetails = !this.isADType
            ? await this.checkAPMTraceDetailExist(data.data.rows)
            : data.data.rows;
          this.items =
            this.offset === 0
              ? this.formatTableResp(dataWithTraceDetails)
              : [...this.items, ...this.formatTableResp(dataWithTraceDetails)];
          if (data.data.rows?.length < LOG_QUERY_TABLE_LIMIT) {
            this.stopInfiniteScroll = true;
          }
          const headersList = data?.data?.columns ?? [];
          this.updateQueryHeaders(headersList);
          this.updateSelectedHeaders(this.queryHeaders);
        } else {
          this.setQueryHeaders([]);
          this.updateSelectedHeaders([]);
        }
        this.loading = false;
        this.queryDataLoading && this.setQueryDataLoading(false);
      } catch (error) {
        this.stopInfiniteScroll = true;
        this.handleQueryDataError(error);
        this.loading = false;
        this.queryDataLoading && this.setQueryDataLoading(false);
        console.log(error);
      }
    },
    async getQueryData(query) {
      if (this.$route.query.isSqlQuery !== 'false') {
        this.getSqlExecData(query);
      } else {
        this.queryTextExec(query);
      }
    },
    handleQueryDataError(error) {
      if (this.items?.length > 18) {
        this.isSrollErrMsg =
          error.status === 404
            ? this.$t('log.timeLapsedReloadDataByClicking')
            : this.$t('log.errorWhileFetchingData');
      } else {
        this.errorMsg =
          error?.data?.errors?.[0]?.message ||
          error?.data?.errors?.message ||
          ((error?.status === 504 || error?.message) &&
            this.$t('log.timeoutErrMsg')) ||
          this.$t('log.querySyntaxNotSupported');
        this.setQueryHeaders(null);
        this.updateSelectedHeaders([]);
      }
    },
    updateSelectedHeaders(headersList) {
      const headersFromParam = this.$route.query.queryFields
        ? customSplitString(this.$route.query.queryFields, ',')
        : [];

      const validHeaders = headersFromParam?.filter((val) =>
        headersList.includes(val),
      );

      if (
        validHeaders.length &&
        validHeaders.length === headersFromParam.length
      )
        return;

      this.$router.push({
        name: getRouteName(this.isADType),
        query: {
          ...this.$route.query,
          queryFields:
            validHeaders.length > 0
              ? validHeaders.slice(0, 5).join(',')
              : headersList.slice(0, 5).join(','),
        },
      });
    },
    handleExpandRow(index) {
      this.items.map((obj, i) => {
        obj.showDetails = i === index ? !obj.showDetails : false;
        return obj;
      });
    },
    handleCopy(content) {
      delete content.showDetails;
      delete content._id;
      copy(JSON.stringify(content));
      notificationSucess(this.$t('copied'));
    },
    getDetailedLog(item) {
      let newItem = { ...item };
      if (this.traceId in newItem && !this.isADType) {
        newItem[this.traceId] = newItem[this.traceId]?.id ?? '';
      }
      delete newItem.showDetails;
      delete newItem._id;
      return newItem;
    },
    resetTableData() {
      this.currentPage = 1;
      this.stopInfiniteScroll = false;
      this.items = [];
      this.setQueryHeaders([]);
      this.setQueryDataLoading(true);
      this.loading = false;
      this.offset = 0;
    },
    redirectToAPMTrace(trace) {
      if (!trace.isAccessible) {
        return notificationError(this.$t('permission-denied'));
      }

      if (trace.id && trace.isTracePresent) {
        this.setCurrentTraceId(trace.id);
        this.$router.push({ name: 'trace' });
      }
    },
    async checkAPMTraceDetailExist(logData) {
      try {
        const traceIDList = logData.reduce((acc, log) => {
          if (log[this.traceId]) {
            acc.push(log[this.traceId]);
          }
          return acc;
        }, []);
        const params = {
          condition: {
            queryDuration: this.getDurationTime,
            queryOrder: 'BY_START_TIME',
            teamId: this.teamID,
            traceIds: traceIDList,
          },
        };
        const data = await this.TRACE_DETAIL_EXIST(params);
        let traceMap = new Map();
        let traceAccessibleMap = new Map();
        Array.isArray(data) &&
          data.forEach((trace) => {
            traceMap.set(trace.traceId, trace.isPresent);
            traceAccessibleMap.set(trace.traceId, trace.isAccessible);
          });
        return logData.map((log) => {
          return log[this.traceId]
            ? {
                ...log,
                [this.traceId]: {
                  id: log[this.traceId],
                  isTracePresent: traceMap.get(log[this.traceId]),
                  isAccessible: traceAccessibleMap.get(log[this.traceId]),
                },
              }
            : log;
        });
      } catch (error) {
        throw new Error(error);
      }
    },
    updateQueryHeaders(newColumns) {
      const headersSet = new Set([...this.queryHeaders, ...newColumns]);
      this.setQueryHeaders([...headersSet]);
    },
    debouncedGetQueryData: debounce(function (val) {
      this.getQueryData(val);
    }, 50),
  },
  watch: {
    '$route.query.queryExec': {
      immediate: true,
      handler(newValue) {
        if (newValue?.length > 0) {
          this.$router.push({
            name: getRouteName(this.isADType),
            query: {
              ...this.$route.query,
              queryFields: '',
            },
          });
          this.resetTableData();
          this.debouncedGetQueryData(newValue);
        }
      },
    },
    '$route.query.queryFields': {
      immediate: true,
      handler() {
        const headers = this.$route.query?.queryFields
          ? customSplitString(this.$route.query.queryFields, ',')
          : [];

        this.headers = headers.map((header) => ({
          key: header,
          name: header,
          width: '20%',
        }));
      },
    },
    getDurationTime() {
      this.resetTableData();
      this.getQueryData(this.$route.query.queryExec);
    },
    freeSearchSources() {
      this.resetTableData();
      this.debouncedGetQueryData(this.$route.query.queryExec);
    },
  },
  created() {
    this.isDestroyed = false;
    this.traceId = TRACE_ID;
    this.LOG_QUERY_TABLE_LIMIT = LOG_QUERY_TABLE_LIMIT;
  },
  unmounted() {
    this.isDestroyed = true;
    this.handleAddNavOptions('');
  },
};
</script>

<template>
  <div>
    <RexTableCompV2
      :headers="headers"
      :items="items"
      :enableDetails="true"
      :enableInfinteScroll="true"
      :loading="loading"
      @fetchNextPageData="
        () => {
          if (items.length > 0 && headers.length > 0 && !stopInfiniteScroll) {
            offset = offset + LOG_QUERY_TABLE_LIMIT;
            getQueryData($route.query.queryExec);
          }
        }
      "
      :hideRows="dispNoDataMessage"
      :enableScrollFooter="dispScrollFooter"
      :striped="true"
      :enableInfiniteScroll="true"
      height="55.725rem"
    >
      <template
        v-for="(header, i) in headers"
        #[`body-${header.key}`]="{ item, index }"
        :key="`${header.key}-${getRandomUniqueId()}`"
      >
        <div v-if="i === 0">
          <BaseIcon
            name="chevronRightIcon"
            @click="() => handleExpandRow(index)"
            height="0.8em"
            width="0.8em"
            class="query-row-expand-icon"
            :style="item.showDetails ? 'transform: rotate(90deg);' : ''"
          />
        </div>

        <div class="query-table-ellipsis-content">
          <span
            v-if="header.key === traceId && !isADType"
            @click="redirectToAPMTrace(item[header.key])"
            :class="
              item[header.key] &&
              item[header.key].isTracePresent &&
              'trace-redirect'
            "
          >
            {{ item[header.key]?.id ?? '' }}
          </span>
          <span v-else>
            {{ item[header.key] }}
          </span>
        </div>
      </template>

      <template v-if="headers.length > 0" #row-details="{ item }">
        <div class="query-row-details">
          <div class="query-row-details-body">
            <pre class="query-row-details-body-text">{{
              getDetailedLog(item)
            }}</pre>
          </div>
          <div
            class="copy-icon-box"
            v-tooltip:right="$t('copy')"
            @click="handleCopy(item)"
          >
            <BaseIcon name="copyNew" iconColor="#f59600" />
          </div>
        </div>
      </template>

      <template #no-data v-if="dispNoDataMessage">
        <NoData :message="errorMsg || $t('log.selectQueryFieldsToViewData')" />
      </template>

      <template v-if="dispInfiniteFooter" #infinite-footer>
        <div class="log-query-infi-footer">
          <div v-if="isSrollErrMsg">
            {{ isSrollErrMsg }}
            <button
              class="query-refresh-btn"
              @click="
                () => {
                  resetTableData();
                  getQueryData($route.query.queryExec);
                }
              "
            >
              <BaseIcon
                name="refresh"
                height="0.8em"
                width="0.8em"
                class="log-query-refresh-icon"
              />
            </button>
          </div>
          <div v-else>
            {{ $t('log.availableDataLoadedCompletely') }}
          </div>
        </div>
      </template>
    </RexTableCompV2>
  </div>
</template>

<style lang="scss" scoped>
.query-table-ellipsis-content {
  @include truncate(95%);
}
.query-row-details {
  background-color: $color-black;
  padding: 1.12rem 0rem 0rem 4.35rem;
  margin-top: -0.1rem;
  display: flex;
  flex-direction: column-reverse;
}
.query-row-details-body {
  max-height: 22.65rem;
  overflow: auto;
}
.query-row-details-body-text {
  color: $color-white;
  padding-bottom: 1.53rem;
  margin-bottom: 0rem;
  margin-right: 1.7rem;
}
.query-row-details-body-text::-webkit-scrollbar {
  height: 0.25rem !important;
}
.query-row-expand-icon {
  margin-left: 0.75rem;
  display: inline-block;
  @include svg-fill-pointer($color-brand-accent);
  margin-right: 3.4rem;
}
.copy-icon-box {
  margin-left: auto;
  cursor: pointer;
  margin-right: 1.7rem;
  @include svg-fill-pointer($color-brand-accent);
}
.log-query-infi-footer {
  @include flex-center;
  color: $font-tertiary;
  padding: 1.25rem 0rem;
}
.query-refresh-btn {
  border: none;
  background-color: inherit;
}
.log-query-refresh-icon {
  @include svg-fill-pointer($color-brand-accent);
}
.trace-redirect {
  cursor: pointer;
  color: $color-brand-accent;
}
.trace-redirect:hover {
  text-decoration: underline;
}
:deep(.body-tr > td) {
  border-bottom: 0.825rem solid $bg-secondary;
}
:deep(.body-tr:last-child > td) {
  border-bottom: none;
}

:deep(td) {
  border-right: none;
}
:deep(.header-td:first-child > div) {
  margin-left: 5rem;
}
</style>
